import React, { useEffect, useState } from "react";

export default function VinylPlayer({ isPlaying, currentTrack, isRandom, setIsRandom, globalStats }) {
  const [showShareModal, setShowShareModal] = useState(false);
  const [currentShareData, setCurrentShareData] = useState({ url: '', text: '' });
  
  useEffect(() => {
    if ('mediaSession' in navigator && currentTrack) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: currentTrack.title || "Streetwise Radio",
        artist: currentTrack.artist || "Streetwise",
        artwork: [{ src: '/favicon.png', sizes: '512x512', type: 'image/png' }]
      });

      // DAS HIER HINZUFÜGEN: Deaktiviert spezifische Audio-Features im Browser-UI
      if (navigator.mediaSession.setActionHandler) {
        try {
          // Wir setzen die Handler auf null, um dem Browser zu sagen: 
          // "Wir bieten hier keinen Text/Untertitel an"
          navigator.mediaSession.setActionHandler('nexttrack', null);
          navigator.mediaSession.setActionHandler('previoustrack', null);
        } catch (e) {}
      }
    }
  }, [currentTrack]);

  // Korrigierte handleShare (nur einmal vorhanden)
  const handleShare = async (type) => {
    const baseUrl = "https://radio.streetwise.studio";
    const shareUrl = type === 'app' ? baseUrl : `${baseUrl}?track=${currentTrack?.id}`;
    const shareText = type === 'app' ? "Listen to streetwise RADIO" : `Check out "${currentTrack?.title}" on streetwise RADIO`;
    
    const shareData = { title: "streetwise RADIO", text: shareText, url: shareUrl };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
      } catch (err) { console.log("Share failed"); }
    } else {
      // Desktop Fallback
      setCurrentShareData({ url: shareUrl, text: shareText });
      setShowShareModal(true);
    }
  };

  // Button Style wie im TV/Studio
  const btnStyle = {
    background: "rgba(0,0,0,0.6)",
    border: "1px solid #00acc1",
    color: "#00acc1",
    padding: "6px 10px",
    borderRadius: "6px",
    fontSize: "0.55rem",
    fontWeight: "900",
    letterSpacing: "1px",
    cursor: "pointer",
    transition: "all 0.2s",
    textDecoration: "none", // Für die Links im Modal
    display: "inline-block"
  };

  // 4. Das Modal-Fenster Komponente
  const ShareModal = () => (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      backgroundColor: "rgba(0,0,0,0.85)", zIndex: 1000, display: "flex",
      alignItems: "center", justifyContent: "center", backdropFilter: "blur(5px)"
    }} onClick={() => setShowShareModal(false)}>
      <div style={{
        background: "#000", border: "2px solid #00acc1", borderRadius: "12px",
        padding: "20px", width: "260px", textAlign: "center", color: "#fff"
      }} onClick={e => e.stopPropagation()}>
        <h3 style={{ color: "#00acc1", marginTop: 0, fontSize: "1rem" }}>SHARE</h3>
        <div style={{ display: "grid", gap: "10px" }}>
          <a href={`https://wa.me/?text=${encodeURIComponent(currentShareData.text + " " + currentShareData.url)}`} target="_blank" rel="noreferrer" style={btnStyle}>WHATSAPP</a>
          <a href={`https://t.me/share/url?url=${encodeURIComponent(currentShareData.url)}&text=${encodeURIComponent(currentShareData.text)}`} target="_blank" rel="noreferrer" style={btnStyle}>TELEGRAM</a>
          <a href={`mailto:?subject=streetwise RADIO&body=${encodeURIComponent(currentShareData.text + " " + currentShareData.url)}`} style={btnStyle}>EMAIL</a>
          <button onClick={() => {
            navigator.clipboard.writeText(currentShareData.url);
            alert("Link copied!");
            setShowShareModal(false);
          }} style={{...btnStyle, background: "#00acc1", color: "#000"}}>COPY LINK</button>
        </div>
        <button onClick={() => setShowShareModal(false)} style={{ background: "none", border: "none", color: "#666", marginTop: "15px", cursor: "pointer", fontSize: "0.7rem" }}>CLOSE</button>
      </div>
    </div>
  );

  return (
    <div className="vinyl-bg-container" style={{ 
      background: "#000", 
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "310px",
      width: "100%",
      overflow: "visible",
    }}>
      
      
      {/* 1. DEZENTER HINTERGRUND-GLOW (Statisch, Weiß/Grau) */}
      <div style={{
        position: "absolute",
        width: "320px",
        height: "320px",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 40%, rgba(0,0,0,0) 70%)",
        zIndex: 1
      }} />

      {/* 2. DIE ROTIERENDE PLATTE (Nur Rillen & Label) */}
      <div 
        className="vinyl-record-disk"
        style={{
          width: "280px",
          height: "280px",
          borderRadius: "50%",
          position: "relative",
          zIndex: 2,
          /* MIX: Grobe Rillen + schwacher mitdrehender Glanz */
          background: `
            linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 50%, rgba(255,255,255,0.05) 100%),
            repeating-radial-gradient(circle, #000 0px, #000 1.5px, #111 2px, #000 2.5px)`,
          boxShadow: "0 20px 50px rgba(0,0,0,1)", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animationName: "rotate-vinyl",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDuration: "3s",
          animationPlayState: isPlaying ? "running" : "paused",
          WebkitAnimationPlayState: isPlaying ? "running" : "paused"
        }}
      >
         {/* LABEL IN DER MITTE */}
         <div style={{ 
           width: "95px", height: "95px", borderRadius: "50%", 
           backgroundColor: "#00acc1", border: "4px solid #000", 
           display: "flex", alignItems: "center", 
           justifyContent: "center", color: "#000",
           boxShadow: "inset 0 0 15px rgba(0,0,0,0.5)",
           zIndex: 5
         }}>
            <span style={{ fontSize: "0.65rem", fontWeight: "900", letterSpacing: "2px" }}>STREETWISE</span>
         </div>
      </div>

      {/* 3. DER STATISCHE OBERFLÄCHEN-GLANZ (JETZT HELLER) */}
      <div style={{
        position: "absolute",
        width: "280px",
        height: "280px",
        borderRadius: "50%",
        zIndex: 10,
        pointerEvents: "none", 
        /* Conic-Gradient: Deckkraft von 0.06 auf 0.12 erhöht für mehr Power */
        background: `conic-gradient(
          from 0deg,
          transparent 5%,
          rgba(255, 255, 255, 0.12) 25%,
          transparent 45%,
          transparent 55%,
          rgba(255, 255, 255, 0.12) 75%,
          transparent 95%
        )`
      }} />

      {/* TITEL & Artist OVERLAY */}
      <div style={{ 
        position: "absolute", 
        bottom: "10px",
        left: 0,
        right: 0, 
        width: "100%", 
        zIndex: 20, 
        display: "flex",
        flexDirection: "column", // Wichtig für Übereinander-Stapelung
        textAlign: "center",
        alignItems: "center"
      }}>

        {/* Zeile für Icon + Titel */}
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          width: "100%", 
          position: "relative", // Wichtig für die absolute Positionierung des Buttons
          padding: "0 15px", // Kleiner Sicherheitsabstand zum Rand
          boxSizing: "border-box"
        }}>
    
        <div style={{ 
          fontSize: "1.4rem", 
          fontWeight: "900", 
          textTransform: "uppercase", 
          letterSpacing: "1px", 
          color: "#fff",
          textShadow: "0 2px 15px rgba(0,0,0,1)"
        }}>
        
        {currentTrack?.title || "STREETWISE"}
        </div>
      </div>
            
        <div style={{ fontSize: "0.85rem", color: "#00acc1", fontWeight: "bold", marginTop: "2px" }}>
          {currentTrack?.artist || "RADIO"}
        </div>
      </div>

      {/* 5. MODAL RENDERN */}
      {showShareModal && <ShareModal />}

    </div>
  );
}